import { Container } from './AddButtonStyles';
import plus from '@/assets/plus_green.svg';
import { cn } from '@/lib/utils';
import { Check } from 'lucide-react';

interface AddButtonProps {
  isAdded?: boolean;
  children?: React.ReactNode;
  onClick?: () => void;
  className?: string;
}

const AddButton = ({ isAdded = false, children, onClick, className }: AddButtonProps) => {
  return (
    <Container
      isAdded={isAdded}
      onClick={onClick}
      className={cn(
        'inline-flex py-2 px-3 items-center gap-1 rounded-full cursor-pointer',
        className,
      )}
    >
      {isAdded ? <Check className="w-4 h-4 mr-2 text-main" /> : <img src={plus} alt="plus" />}
      {children}
    </Container>
  );
};

export default AddButton;
